
import Vue from 'vue'
import AppMixin from '@/_mixins/app'
import lodash from 'lodash'
import {
    searchCompanyAdminsByCompany,
    confirmAccessToAllCompanyProjects,
} from '@/views/Authorization/utils/authorization'
import { searchUsers } from '@/utils/user'
import {
    initDeleteAdmin,
    initPostAdmin,
    patchAdmin,
    searchCompanyAdminsByUser,
} from '@/views/Authorization/utils/authorization'
import UserAvatar from '@/views/User/components/userAvatar.vue'

const CompanyAdmins = Vue.extend({
    mixins: [AppMixin],
    components: { UserAvatar },
    props: {
        company: {
            type: Object,
            required: true,
        },
        searchTerm: {
            type: String,
            required: false,
            default: '',
        },
    },

    data() {
        return {
            loading: false,
            infiniteId: 0,
            offsetUser: 0,
            limit: 20,
            admins: [] as Array<any>,
            users: [] as Array<any>,
        }
    },

    computed: {
        filteredUsers() {
            return this.searchTerm && this.searchTerm.length > 0
                ? this.lodash
                      .uniqBy([...this.admins, ...this.users], 'id')
                      .filter((user: any) =>
                          user.name.toLowerCase().includes(this.searchTerm.toLowerCase())
                      )
                : this.admins
        },
    },

    methods: {
        initiateAdmins() {
            this.offsetUser = 0
            this.infiniteId = Date.now()
            this.users = []
        },

        async loadAdmins() {
            this.loading = true

            const res = await searchCompanyAdminsByCompany(this.company.id)

            const users = res.map((admin: any) => {
                return {
                    ...admin.user.data,
                    admin: admin.id,
                    giveAccessToAllProjects: admin.giveAccessToAllProjects,
                    constraints: admin.constraints,
                }
            })

            this.admins = users

            this.loading = false
        },

        async loadUsers($state: any) {
            this.loading = true

            let res = await searchUsers({
                'filter[kind]': 'normal',
                'page[offset]': this.offsetUser,
                'page[limit]': this.limit,
                'filter[searchTerm]': this.searchTerm,
            })

            this.users = [...this.users, ...res]

            if (res.length == this.limit) {
                $state.loaded()
                this.offsetUser += this.limit
            } else {
                $state.complete()
            }
            this.loading = false
        },

        async addAdmin(user: Record<string, any>) {
            const res = await initPostAdmin(user, this.company)

            if (res.id && this.currentUser.id) {
                this.admins.push(res)
                if (res.id == this.currentUser.id) {
                    await searchCompanyAdminsByUser(this.currentUser.id, true)
                }
            }
        },

        async deleteAdmin(user: Record<string, any>) {
            await initDeleteAdmin(user, this.company.name)

            this.admins.splice(
                this.admins.findIndex((admin) => admin.admin == user.admin),
                1
            )
            delete user.admin
        },

        async updateAdminProjectAccess(user: Record<string, any>) {
            if (user.giveAccessToAllProjects) {
                confirmAccessToAllCompanyProjects(user, this.company)
            } else {
                patchAdmin(user.admin, {
                    giveAccessToAllProjects: false,
                })
            }
        },
    },

    watch: {
        company: {
            immediate: true,
            deep: true,
            handler() {
                this.loading = true
                this.loadAdmins()
                this.initiateAdmins()
            },
        },
        searchTerm: lodash.debounce(function (this) {
            this.initiateAdmins()
        }, 600),
    },
})

export default CompanyAdmins
